import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

const controlRedirectFrom = process.env.REACT_APP_CONTROL_REDIRECT_FROM;
const controlRedirectTo = process.env.REACT_APP_CONTROL_REDIRECT_TO;

const shouldRedirect = (() => {
  if (
    !controlRedirectFrom
    || !controlRedirectTo
    || window.location.hostname !== controlRedirectFrom
  ) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const { pathname } = window.location;
  const back = params.get('back') || '';

  const isControlUrl = pathname.startsWith('/control') && params.has('code');
  const isKioskUrl = pathname.startsWith('/kiosk/')
    && back.startsWith('/control') && back.includes('code=');

  if (isControlUrl || isKioskUrl) {
    window.location.replace(
      `https://${controlRedirectTo}${window.location.pathname}${window.location.search}`,
    );

    return true;
  }

  return false;
})();

if (!shouldRedirect) {
  const container = document.getElementById('root');

  const root = createRoot(container!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
